<template>
  <div class="personal-details">
    <form class="edit-form" @submit.prevent="submit">
      <div class="personal-details-fields">
        <label :class="{ error: errors.first_name }">
          {{ $t("שם פרטי") }}
          <input
            v-model="edit.first_name"
            id="personal-first-name"
            type="text"
            :disabled="!editing"
          />
          <div v-if="errors.first_name" class="field-error">
            {{ errors.first_name }}
          </div>
        </label>

        <label :class="{ error: errors.last_name }">
          {{ $t("שם משפחה") }}
          <input
            v-model="edit.last_name"
            id="personal-last-name"
            type="text"
            :disabled="!editing"
          />
          <div v-if="errors.last_name" class="field-error">
            {{ errors.last_name }}
          </div>
        </label>

        <label :class="{ error: errors.mailing_street }">
          {{ $t("כתובת למשלוח דואר") }}
          <input
            v-model="edit.mailing_street"
            id="personal-mailing-street"
            type="text"
            :disabled="!editing"
          />
          <div v-if="errors.mailing_street" class="field-error">
            {{ errors.mailing_street }}
          </div>
        </label>

        <label :class="{ error: errors.mailing_city }">
          {{ $t("עיר למשלוח דואר") }}
          <input
            v-model="edit.mailing_city"
            id="personal-mailing-city"
            type="text"
            :disabled="!editing"
          />
          <div v-if="errors.mailing_city" class="field-error">
            {{ errors.mailing_city }}
          </div>
        </label>

        <label :class="{ error: errors.phone }">
          {{ $t("טלפון") }}
          <input
            v-model="edit.phone"
            id="personal-phone"
            type="tel"
            :disabled="!editing"
          />
          <div v-if="errors.phone" class="field-error">{{ errors.phone }}</div>
        </label>

        <label :class="{ error: errors.mailing_postal_code }">
          {{ $t("מיקוד") }}
          <input
            v-model="edit.mailing_postal_code"
            id="personal-mailing-postal-code"
            type="tel"
            :disabled="!editing"
          />
          <div v-if="errors.mailing_postal_code" class="field-error">
            {{ errors.mailing_postal_code }}
          </div>
        </label>

        <label :class="{ error: errors.email }">
          {{ $t("אימייל") }}
          <input
            v-model="edit.email"
            id="personal-email"
            type="email"
            :disabled="!editing"
          />
          <div v-if="errors.email" class="field-error">{{ errors.email }}</div>
        </label>
      </div>

      <div v-if="editing" class="personal-details-form-actions">
        <button :disabled="sending" type="submit" class="dark-blue-button">
          <div v-if="sending" class="css-loader css-loader-small"></div>
          <span v-else>{{ sending ? $t("שומר...") : $t("שמור שינויים") }}</span>
        </button>
        <button
          :disabled="sending"
          class="outline-button"
          @click="toggleEditing"
        >
          {{ $t("ביטול") }}
        </button>
      </div>

      <div v-if="editing && success" class="form-success">
        {{ $t("השינויים נשמרו בהצלחה.") }}
      </div>
    </form>
    <div>
      <div v-if="editing" class="personal-details-form-actions-mobile">
        <a href="#" class="link-button" @click.prevent="toggleEditing">{{
          $t("ביטול")
        }}</a>
        <a href="#" class="link-button" @click.prevent="submit">{{
          sending ? $t("שומר...") : $t("שמור שינויים")
        }}</a>
      </div>
      <a
        href="#"
        :class="{
          'link-button': true,
          'personal-details-edit-button': true,
          'personal-details-edit-button-hidden': editing,
        }"
        @click.prevent="toggleEditing"
      >
        <i class="icon icon-pencil"></i>
        {{ $t("ערוך") }}
      </a>
    </div>
  </div>
</template>

<script>
import { api } from "../../API";

export default {
  props: {
    profile: {
      type: Object,
      default: () => {
        return {
          first_name: "חן",
          last_name: "כהן",
          mailing_street: "רחוב החרמון 4",
          mailing_city: "נתניה",
          mailing_postal_code: "784521",
          phone: "052-784123698",
          email: "Chen_Cohen@gmail.com",
        };
      },
    },
  },

  data() {
    return {
      editing: false,
      original: JSON.parse(JSON.stringify(this.profile)),
      edit: JSON.parse(JSON.stringify(this.profile)),

      sending: false,
      success: false,
      errors: {},
    };
  },

  methods: {
    toggleEditing() {
      this.editing = !this.editing;
      this.edit = JSON.parse(JSON.stringify(this.original));

      // Reset previous submit.
      this.sending = false;
      this.success = false;
      this.errors = {};
    },

    submit() {
      this.sending = true;
      this.success = false;
      this.errors = {};

      api
        .customerUpdate(this.edit)
        .then((resp) => {
          this.original = this.edit;
          this.success = true;
        })
        .catch((err) => {
          if (err.responseJSON && err.responseJSON.data) {
            this.errors = err.responseJSON.data.errors;
          }
          this.success = false;
        })
        .finally(() => {
          this.sending = false;
        });
    },
  },
};
</script>
